import Vue from "vue"

const shoppingCart = {
	namespaced: true,
	state: {
		items: [],
	},

	mutations: {
		setItems(state, payload) {
			state.items = payload;
		},
	},

	actions: {
		loadItems({ commit }) {
			let items = Vue.cookie.get("shoppingCart");

			if (items) {
				commit("setItems", JSON.parse(Vue.cookie.get("shoppingCart")));
			} else {
				commit("setItems", []);
			}
		},

		addItem({ commit, state }, item) {
			const items = [...state.items, item];
			commit("setItems", items);
			Vue.cookie.set("shoppingCart", JSON.stringify(items));
		},

		removeItem({ commit, state }, item) {
			const items = state.items.filter((i) => i.uuid !== item.uuid);
			commit("setItems", items);
			Vue.cookie.set("shoppingCart", JSON.stringify(items));
		},

		updateItem({ commit, state }, item) {
			const items = state.items.map((i) => {
				if (i.uuid === item.uuid) {
					return { ...i, ...item };
				}
				return i;
			});

			commit("setItems", items);
			Vue.cookie.set("shoppingCart", JSON.stringify(items));
		},

		clearItems({ commit }) {
			commit("setItems", []);
			Vue.cookie.set("shoppingCart", []);
		},
	},

	getters: {
		items(state) {
			return state.items;
		},

		itemCount(state) {
			return state.items.length;
		},

		itemTotal(state) {
			return state.items.reduce((total, item) => {
				return total + (item.price * item.quantity);
			}, 0);
		},

		itemTotalTable(state) {
			return state.items.reduce((total, item) => {
				return total + (item.priceTable * item.quantity);
			}, 0);
		}
	},
}

export default shoppingCart;